export const teams = ['admin', 'contracting'];

export const permissionTypes = [
  {
    label: 'Profile',
    value: 'profile',
    hintTextMultiLoc: 'Gives the user profile access to the selected locations.',
    hintTextSingleLoc: 'Gives the user access to the profile.',
  },
  {
    label: 'User Management',
    value: 'admin',
    hintTextMultiLoc: 'Gives the user access to the selected locations.',
    hintTextSingleLoc: 'Gives the user access to user management.',
  },
  {
    label: 'Contracting',
    value: 'contracting',
    hintTextMultiLoc: 'Gives the user contracting access to the selected locations.',
    hintTextSingleLoc: 'Gives the user contracting access.',
  },
];

export const availableAccess = [
  {
    label: 'Read and Write',
    value: ['read', 'write'],
  },
  {
    label: 'Read Only',
    value: ['read'],
  },
  {
    label: 'No Access',
    value: [],
  },
];



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/teamPermissionOptions.jsx